import React from "react";
import Context from "./context.js";
import { Form, Button, Container, Card, Image, Spinner, Badge } from 'react-bootstrap';
import axios from "axios";
import MultiSelect from "@kenshooui/react-multi-select";
import "@kenshooui/react-multi-select/dist/style.css"
import Cookies from "universal-cookie";
import {
    FaArrowLeft,
    FaUser,
    FaPhone,
    FaMapMarkerAlt,
    FaMoneyBillWave,
    FaStickyNote,
    FaShoppingCart,
    FaHistory,
    FaCheckCircle,
    FaTruck,
    FaTimesCircle,
    FaExclamationCircle,
    FaPlus,
    FaMinus,
    FaStore
} from "react-icons/fa";
import { Link } from 'react-router-dom';
import host from "./host";
import moment from "moment";

const cookies = new Cookies();

class Outs extends React.Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pages: [],
            orders: [],
            selectedItems: [],
            productQuantities: {}, // لتتبع كميات المنتجات
            isLoading: true,
            isSubmitting: false,
            activeSection: 0,
            formData: {
                name: '',
                account: '',
                phone: '',
                city: '1',
                address: '',
                pageId: 'non',
                price: '',
                notes: '',
                orderType: 'new'
            },
            errors: {}
        };
        this.styleSheetRef = null;
    }

    componentDidMount() {
        // Add page-specific styles
        this.addPageStyles();
        
        var header = { "Content-Type": "application/json", Authorization: cookies.get("token") };

        Promise.all([
            axios.get(host + `users/all/items/`, { headers: header }),
            axios.get(host + `users/pages/name/all`, { headers: header })
        ]).then((responses) => {
            this.setState({
                items: responses[0].data.data.data,
                pages: responses[1].data.data.pages,
                isLoading: false
            });
        }).catch((error) => {
            this.setState({ isLoading: false });
        });
    }

    componentWillUnmount() {
        // Remove page-specific styles when component unmounts
        if (this.styleSheetRef && this.styleSheetRef.parentNode) {
            this.styleSheetRef.parentNode.removeChild(this.styleSheetRef);
        }
    }

    addPageStyles = () => {
        this.styleSheetRef = document.createElement("style");
        this.styleSheetRef.textContent = `
            /* Scoped styles for Outs page only */
            .outs-page-container {
                direction: rtl;
            }

            .outs-page-container * {
                direction: rtl;
            }

            /* Animations */
            @keyframes slideIn {
                from { opacity: 0; transform: translateY(20px); }
                to { opacity: 1; transform: translateY(0); }
            }

            /* Apply animations */
            .outs-page-container .card { animation: slideIn 0.5s ease-out; }

            /* Hover effects */
            .outs-page-container input:focus,
            .outs-page-container select:focus,
            .outs-page-container textarea:focus {
                border-color: #6366f1 !important;
                background-color: white !important;
            }

            .outs-page-container .btn:hover:not(:disabled) {
                transform: translateY(-2px);
                box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
            }

            .outs-page-container .btn:active:not(:disabled) {
                transform: translateY(0);
            }

            /* Quantity buttons hover */
            .outs-page-container button:hover {
                transform: scale(1.05);
            }

            /* Back button hover */
            .outs-page-container a:hover {
                color: #4f46e5 !important;
            }

            /* Custom scrollbar for this page */
            .outs-page-container ::-webkit-scrollbar {
                width: 8px;
                height: 8px;
            }

            .outs-page-container ::-webkit-scrollbar-track {
                background: #f1f3f5;
                border-radius: 4px;
            }

            .outs-page-container ::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 4px;
            }

            .outs-page-container ::-webkit-scrollbar-thumb:hover {
                background: #94a3b8;
            }

            /* Order cards animation and hover */
            .outs-page-container .order-card {
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                cursor: pointer;
            }

            .outs-page-container .order-card:hover {
                transform: translateY(-4px);
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
            }

            .outs-page-container .order-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 4px;
                background: linear-gradient(90deg, #6366f1 0%, #8b5cf6 100%);
                opacity: 0;
                transition: opacity 0.3s;
            }

            .outs-page-container .order-card:hover::before {
                opacity: 1;
            }

            /* Orders grid custom scrollbar */
            .outs-page-container .orders-grid::-webkit-scrollbar {
                width: 6px;
            }

            .outs-page-container .orders-grid::-webkit-scrollbar-track {
                background: rgba(99, 102, 241, 0.05);
                border-radius: 3px;
            }

            .outs-page-container .orders-grid::-webkit-scrollbar-thumb {
                background: rgba(99, 102, 241, 0.3);
                border-radius: 3px;
            }

            .outs-page-container .orders-grid::-webkit-scrollbar-thumb:hover {
                background: rgba(99, 102, 241, 0.5);
            }

            /* Multi-select custom styles with RTL */
            .outs-page-container .multi-select__menu {
                border-radius: 12px !important;
                border: 2px solid #e5e7eb !important;
                box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
                text-align: right !important;
            }

            .outs-page-container .multi-select__input {
                padding: 12px 16px !important;
                font-size: 16px !important;
                background-color: #f9fafb !important;
                text-align: right !important;
                direction: rtl !important;
            }

            .outs-page-container .multi-select__option {
                text-align: right !important;
                padding-right: 16px !important;
            }

            .outs-page-container .multi-select__option--selected {
                background-color: #6366f1 !important;
                color: white !important;
            }

            /* RTL specific adjustments */
            .outs-page-container .form-control,
            .outs-page-container .form-select {
                text-align: right !important;
                direction: rtl !important;
            }

            .outs-page-container select {
                background-position: left 0.75rem center !important;
                padding-right: 16px !important;
                padding-left: 40px !important;
            }

            /* Icon positioning for RTL */
            .outs-page-container .input-icon {
                right: auto !important;
                left: 16px !important;
            }

            /* Mobile responsive */
            @media (max-width: 768px) {
                .outs-page-container .header-content {
                    padding: 12px 16px !important;
                }

                .outs-page-container .page-title {
                    font-size: 20px !important;
                }

                .outs-page-container .progress-bar {
                    padding: 16px !important;
                    overflow-x: auto;
                    direction: rtl;
                }

                .outs-page-container .progress-step {
                    min-width: 80px;
                }

                .outs-page-container .progress-icon {
                    width: 40px !important;
                    height: 40px !important;
                    font-size: 18px !important;
                }

                .outs-page-container .progress-label {
                    font-size: 12px !important;
                }

                .outs-page-container .main-container {
                    padding: 0 16px !important;
                }

                .outs-page-container .form-grid {
                    grid-template-columns: 1fr !important;
                }

                .outs-page-container .order-type-options {
                    grid-template-columns: 1fr !important;
                }

                .outs-page-container .products-grid {
                    grid-template-columns: 1fr !important;
                }

                .outs-page-container .submit-button {
                    width: 100%;
                    padding: 14px 32px !important;
                    font-size: 16px !important;
                }

                .outs-page-container .card-body {
                    padding: 20px !important;
                }

                .outs-page-container .section-title {
                    font-size: 18px !important;
                }
                
                /* Previous Orders Mobile Optimization */
                .outs-page-container .previous-orders {
                    padding: 16px !important;
                    margin-top: 20px !important;
                }
                
                .outs-page-container .previous-orders-header {
                    flex-direction: column !important;
                    align-items: flex-start !important;
                    gap: 8px !important;
                }
                
                .outs-page-container .previous-orders-title {
                    font-size: 16px !important;
                }
                
                .outs-page-container .orders-grid {
                    grid-template-columns: 1fr !important;
                    max-height: 400px !important;
                    gap: 10px !important;
                }
                
                .outs-page-container .order-card {
                    padding: 14px !important;
                }
                
                .outs-page-container .order-card-header {
                    gap: 8px !important;
                }
                
                .outs-page-container .order-id-badge {
                    padding: 4px 8px !important;
                    font-size: 12px !important;
                }
                
                .outs-page-container .order-status-badge {
                    padding: 4px 8px !important;
                    font-size: 11px !important;
                }
                
                .outs-page-container .order-detail-item {
                    font-size: 12px !important;
                    gap: 6px !important;
                }
                
                .outs-page-container .order-detail-icon {
                    font-size: 14px !important;
                }
                
                .outs-page-container .order-card-footer {
                    padding-top: 8px !important;
                }
                
                .outs-page-container .order-date,
                .outs-page-container .order-time {
                    font-size: 11px !important;
                }
            }

            @media (max-width: 480px) {
                .outs-page-container .product-card {
                    flex-direction: column;
                    text-align: center;
                }

                .outs-page-container .product-image {
                    width: 100px !important;
                    height: 100px !important;
                    margin: 0 auto;
                }

                .outs-page-container .quantity-control {
                    justify-content: center;
                }
            }

            /* Loading animation */
            @keyframes pulse {
                0%, 100% { opacity: 1; }
                50% { opacity: 0.5; }
            }

            .outs-page-container .loading-card {
                animation: pulse 2s ease-in-out infinite;
            }

            /* Fix Bootstrap RTL issues */
            .outs-page-container .container {
                direction: rtl !important;
            }

            .outs-page-container .row {
                direction: rtl !important;
            }

            .outs-page-container .card {
                direction: rtl !important;
                text-align: right !important;
            }

            /* Progress bar RTL */
            .outs-page-container .progress-bar {
                direction: rtl !important;
            }

            /* Badge RTL */
            .outs-page-container .badge {
                margin-right: 0 !important;
                margin-left: 8px !important;
            }

            /* Ensure all text is right-aligned */
            .outs-page-container h1,
            .outs-page-container h2,
            .outs-page-container h3,
            .outs-page-container h4,
            .outs-page-container h5,
            .outs-page-container h6,
            .outs-page-container p,
            .outs-page-container span,
            .outs-page-container div {
                text-align: right !important;
            }

            /* Center aligned items should remain centered */
            .outs-page-container .text-center {
                text-align: center !important;
            }
        `;
        document.head.appendChild(this.styleSheetRef);
    }

    handleInputChange = (field, value) => {
        this.setState(prevState => ({
            formData: { ...prevState.formData, [field]: value },
            errors: { ...prevState.errors, [field]: '' }
        }));

        // Check phone for previous orders
        if (field === 'phone' && value.length === 11) {
            axios.get(host + `users/orders/check?phone=${value}`)
                .then((res) => {
                    if (res.data.data.orders.length > 0) {
                        this.setState({ orders: res.data.data.orders });
                    }
                })
        }
    }

    validateForm = () => {
        const { formData, selectedItems } = this.state;
        const errors = {};

        if (selectedItems.length === 0) {
            errors.items = 'يجب اختيار منتج واحد على الأقل';
        }
        
        // التحقق الصارم من رقم الهاتف - 11 رقم بالضبط
        if (!formData.phone) {
            errors.phone = 'رقم الهاتف مطلوب';
        } else if (formData.phone.length < 11) {
            errors.phone = `رقم الهاتف ناقص - مُدخل ${formData.phone.length} رقم من أصل 11`;
        } else if (formData.phone.length > 11) {
            errors.phone = 'رقم الهاتف أطول من المطلوب - يجب أن يكون 11 رقم فقط';
        } else if (formData.phone.length === 11) {
            // التحقق من أن جميع المحارف أرقام
            if (!/^[0-9]{11}$/.test(formData.phone)) {
                errors.phone = 'رقم الهاتف يجب أن يحتوي على أرقام إنجليزية فقط';
            }
        }
        
        if (formData.city === '1') {
            errors.city = 'يجب اختيار المحافظة';
        }
        if (formData.pageId === 'non') {
            errors.pageId = 'يجب اختيار الصفحة';
        }
        
        // التحقق من السعر - يجب أن يكون موجود والحد الأدنى 5
        if (!formData.price) {
            errors.price = 'السعر مطلوب';
        } else if (parseFloat(formData.price) < 5) {
            errors.price = 'الحد الأدنى للسعر هو 5';
        } else if (parseFloat(formData.price) <= 0) {
            errors.price = 'السعر يجب أن يكون أكبر من صفر';
        }

        // التحقق من المخزون
        const stockValidation = this.validateStock();
        if (!stockValidation.valid) {
            errors.stock = stockValidation.message;
            alert(stockValidation.message);
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }

    // التحقق من المخزون قبل الإرسال
    validateStock = () => {
        const { selectedItems, productQuantities } = this.state;
        
        for (const item of selectedItems) {
            const quantity = productQuantities[item.id] || 1;
            if (quantity > item.count) {
                return {
                    valid: false,
                    message: `المنتج "${item.label}" - الكمية المطلوبة (${quantity}) تتجاوز المخزون (${item.count})`
                };
            }
        }
        
        return { valid: true };
    }

    // دالة محدثة لتغيير الكمية باستخدام state
    onChangeQuantity = (itemId, delta, item) => {
        try {
            const { productQuantities } = this.state;
            const currentQuantity = productQuantities[itemId] || 1;
            const newQuantity = currentQuantity + delta;

            if (newQuantity >= 1 && newQuantity <= item.count) {
                this.setState(prevState => ({
                    productQuantities: {
                        ...prevState.productQuantities,
                        [itemId]: newQuantity
                    }
                }));
            } else if (newQuantity > item.count) {
                alert(`الكمية المطلوبة تتجاوز المخزون المتاح (${item.count})`);
            }
        } catch (error) {
            console.error('Error updating quantity:', error);
        }
    }

    // حساب السعر التلقائي (اختياري - يمكنك استخدامه إذا كانت المنتجات لها أسعار)
    calculateTotalPrice = () => {
        const { selectedItems, productQuantities } = this.state;
        let total = 0;
        
        selectedItems.forEach(item => {
            const quantity = productQuantities[item.id] || 1;
            total += (item.price || 0) * quantity;
        });
        
        return total;
    }

    submit = () => {
        if (!this.validateForm()) return;

        this.setState({ isSubmitting: true });

        const { formData, selectedItems, productQuantities } = this.state;
        let items = [];
        let notes2 = '';

        selectedItems.forEach((item, index) => {
            const count = productQuantities[item.id] || 1; // استخدم state بدلاً من DOM
            const obj = { id: item.id, name: item.label, count };
            notes2 += index === 0 ? `(${count} * ${obj.name})` : ` / (${count} * ${obj.name})`;
            items.push(obj);
        });

        let bodyFormData = new FormData();
        Object.keys(formData).forEach(key => {
            if (key === 'city') bodyFormData.append('government', formData[key]);
            else if (key === 'address') bodyFormData.append('city', formData[key]);
            else if (key === 'pageId') bodyFormData.append('page_name', formData[key]);
            else bodyFormData.append(key, formData[key]);
        });

        bodyFormData.append('notes2', notes2);
        bodyFormData.append('items', JSON.stringify(items));
        bodyFormData.append('dep', formData.orderType === 'dep');
        bodyFormData.append('rep', formData.orderType === 'rep');

        axios({
            method: 'post',
            url: host + 'users/user/from/order/add',
            headers: { 'Authorization': cookies.get("token") },
            data: bodyFormData
        }).then((response) => {
            window.location.href = '/Done';
        }).catch((error) => {
            this.setState({ isSubmitting: false });
            window.location.href = '/Error';
        });
    }

    renderStatusIcon = (status) => {
        const iconProps = { size: 24 };
        switch (status) {
            case 0: return <FaExclamationCircle {...iconProps} style={styles.statusIcon.waiting} />;
            case 1: return <FaTruck {...iconProps} style={styles.statusIcon.delivery} />;
            case 2: return <FaTimesCircle {...iconProps} style={styles.statusIcon.cancelled} />;
            case 3: return <FaCheckCircle {...iconProps} style={styles.statusIcon.success} />;
            case 4: return <FaTimesCircle {...iconProps} style={styles.statusIcon.returned} />;
            default: return null;
        }
    }

    getStatusText = (status) => {
        const statusMap = {
            0: 'انتظار',
            1: 'قيد التوصيل',
            2: 'ملغي',
            3: 'تم التسليم',
            4: 'مرتجع',
            '-1': 'لا يرد',
            '-2': 'غير مؤكد',
            '-3': 'غير متوفر'
        };
        return statusMap[status] || 'غير معروف';
    }

    render() {
        const { items, selectedItems, isLoading, isSubmitting, formData, errors, orders, pages, productQuantities } = this.state;

        if (isLoading) {
            return (
                <div className="outs-page-container" style={styles.loadingContainer}>
                    <div className="loading-card" style={styles.loadingCard}>
                        <Spinner animation="grow" style={styles.loadingSpinner} />
                        <h4 style={styles.loadingTitle}>جاري التحميل</h4>
                        <p style={styles.loadingSubtitle}>يرجى الانتظار...</p>
                    </div>
                </div>
            );
        }

        const sections = [
            { icon: <FaUser />, title: 'معلومات الزبون' },
            { icon: <FaMapMarkerAlt />, title: 'معلومات التوصيل' },
            { icon: <FaShoppingCart />, title: 'المنتجات' },
            { icon: <FaMoneyBillWave />, title: 'التفاصيل النهائية' }
        ];

        return (
            <div className="outs-page-container" style={styles.pageContainer}>
                {/* Modern Header */}
                <div style={styles.header}>
                    <Container className="header-content" style={styles.headerContent}>
                        <Link to='/' style={styles.backButton}>
                            <FaArrowLeft />
                            <span>رجوع</span>
                        </Link>
                        <h1 className="page-title" style={styles.pageTitle}>طلب جديد</h1>
                    </Container>
                </div>

                {/* Progress Bar */}
                <Container className="progress-container" style={styles.progressContainer}>
                    <div className="progress-bar" style={styles.progressBar}>
                        {sections.map((section, index) => (
                            <div key={index} className="progress-step" style={styles.progressStep}>
                                <div className="progress-icon" style={{
                                    ...styles.progressIcon,
                                    ...(this.state.activeSection >= index ? styles.progressIconActive : {})
                                }}>
                                    {section.icon}
                                </div>
                                <span className="progress-label" style={styles.progressLabel}>{section.title}</span>
                            </div>
                        ))}
                    </div>
                </Container>

                {/* Main Content */}
                <Container className="main-container" style={styles.mainContainer}>
                    <div style={styles.contentWrapper}>
                        {/* Customer Information Section */}
                        <Card style={styles.sectionCard}>
                            <Card.Body>
                                <div style={styles.sectionHeader}>
                                    <FaUser style={styles.sectionIcon} />
                                    <h2 className="section-title" style={styles.sectionTitle}>معلومات الزبون</h2>
                                </div>

                                <div className="form-grid" style={styles.formGrid}>
                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>اسم الزبون</label>
                                        <input
                                            type="text"
                                            style={{ ...styles.input, ...(errors.name ? styles.inputError : {}) }}
                                            placeholder="أدخل اسم الزبون"
                                            value={formData.name}
                                            onChange={(e) => this.handleInputChange('name', e.target.value)}
                                        />
                                        {errors.name && <span style={styles.errorText}>{errors.name}</span>}
                                    </div>

                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>رابط حساب الزبون</label>
                                        <input
                                            type="text"
                                            style={styles.input}
                                            placeholder="رابط فيسبوك أو انستغرام"
                                            value={formData.account}
                                            onChange={(e) => this.handleInputChange('account', e.target.value)}
                                        />
                                    </div>

                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>رقم الهاتف *</label>
                                        <input
                                            type="tel"
                                            style={{ 
                                                ...styles.input, 
                                                ...(errors.phone ? styles.inputError : {}),
                                                ...(formData.phone && formData.phone.length === 11 ? { borderColor: '#10b981' } : {})
                                            }}
                                            placeholder="07XXXXXXXXX (11 رقم بالضبط)"
                                            value={formData.phone}
                                            onChange={(e) => {
                                                // السماح فقط بالأرقام الإنجليزية
                                                const value = e.target.value.replace(/[^0-9]/g, '');
                                                
                                                // منع إدخال أكثر من 11 رقم
                                                if (value.length <= 11) {
                                                    this.handleInputChange('phone', value);
                                                }
                                            }}
                                            onPaste={(e) => {
                                                // معالجة حدث اللصق
                                                e.preventDefault();
                                                const pastedText = e.clipboardData.getData('text');
                                                const cleanedValue = pastedText.replace(/[^0-9]/g, '');
                                                
                                                if (cleanedValue.length > 11) {
                                                    // إظهار تحذير ولا تدخل أي شيء إذا كان الرقم أكثر من 11
                                                    alert(`⚠️ خطأ!\n\nالرقم الذي تحاول لصقه يحتوي على ${cleanedValue.length} رقم.\n\nيجب أن يكون رقم الهاتف 11 رقم بالضبط.\n\nيرجى نسخ رقم صحيح مكون من 11 رقم فقط.`);
                                                    // لا تفعل شيء - احتفظ بالقيمة الحالية
                                                } else if (cleanedValue.length === 11) {
                                                    // قبول الرقم إذا كان 11 رقم بالضبط
                                                    this.handleInputChange('phone', cleanedValue);
                                                } else if (cleanedValue.length < 11 && cleanedValue.length > 0) {
                                                    // إدخال الرقم إذا كان أقل من 11 (يمكن للمستخدم إكماله)
                                                    this.handleInputChange('phone', cleanedValue);
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                // منع إدخال أي شيء غير الأرقام
                                                const charCode = e.which ? e.which : e.keyCode;
                                                if (charCode < 48 || charCode > 57) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            maxLength="11"
                                        />
                                        {/* رسالة الخطأ عند محاولة الإرسال */}
                                        {errors.phone && <span style={styles.errorText}>{errors.phone}</span>}
                                        
                                        {/* مؤشر حالة الإدخال */}
                                        {formData.phone && formData.phone.length > 0 && (
                                            <span style={{ 
                                                fontSize: '12px',
                                                color: formData.phone.length === 11 ? '#10b981' : '#f59e0b',
                                                fontWeight: '500'
                                            }}>
                                                {formData.phone.length === 11 
                                                    ? '✓ رقم الهاتف صحيح' 
                                                    : `يجب إدخال 11 رقم بالضبط (المُدخل: ${formData.phone.length}/11)`
                                                }
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* Previous Orders */}
                                {orders.length > 0 && (
                                    <div className="previous-orders" style={styles.previousOrders}>
                                        <div className="previous-orders-header" style={styles.previousOrdersHeader}>
                                            <h3 className="previous-orders-title" style={styles.previousOrdersTitle}>
                                                <FaHistory /> الطلبات السابقة
                                            </h3>
                                            <span style={styles.orderCount}>({orders.length} طلب)</span>
                                        </div>
                                        <div className="orders-grid" style={styles.ordersGrid}>
                                            {orders.map((order, i) => (
                                                <div 
                                                    key={i} 
                                                    style={{
                                                        ...styles.orderCard,
                                                        ...(order.status === 3 ? styles.orderCardSuccess :
                                                            order.status === 2 || order.status === 4 ? styles.orderCardDanger :
                                                            styles.orderCardWarning)
                                                    }} 
                                                    className="order-card"
                                                >
                                                    <div className="order-card-header" style={styles.orderCardHeader}>
                                                        <div className="order-id-badge" style={styles.orderIdBadge}>
                                                            <span style={styles.orderIdText}>#{order.id}</span>
                                                        </div>
                                                        <div className="order-status-badge" style={{
                                                            ...styles.orderStatusBadge,
                                                            ...(order.status === 3 ? styles.statusBadgeSuccess :
                                                                order.status === 2 || order.status === 4 ? styles.statusBadgeDanger :
                                                                styles.statusBadgeWarning)
                                                        }}>
                                                            {this.renderStatusIcon(order.status)}
                                                            <span>{this.getStatusText(order.status)}</span>
                                                        </div>
                                                    </div>
                                                    
                                                    <div style={styles.orderCardBody}>
                                                        <div className="order-detail-item" style={styles.orderDetailItem}>
                                                            <FaUser className="order-detail-icon" style={styles.orderDetailIcon} />
                                                            <span style={styles.orderDetailLabel}>المجهز:</span>
                                                            <span style={styles.orderDetailValue}>{order.user.name}</span>
                                                        </div>
                                                        
                                                        <div className="order-detail-item" style={styles.orderDetailItem}>
                                                            <FaShoppingCart className="order-detail-icon" style={styles.orderDetailIcon} />
                                                            <span style={styles.orderDetailLabel}>المنتجات:</span>
                                                            <span style={styles.orderDetailValue}>{order.notes2}</span>
                                                        </div>
                                                        
                                                        <div className="order-detail-item" style={styles.orderDetailItem}>
                                                            <FaMoneyBillWave className="order-detail-icon" style={styles.orderDetailIcon} />
                                                            <span style={styles.orderDetailLabel}>السعر:</span>
                                                            <span style={styles.orderDetailValue}>{order.price} IQD</span>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="order-card-footer" style={styles.orderCardFooter}>
                                                        <span className="order-date" style={styles.orderDate}>
                                                            {moment(order.add_at).format('DD MMM YYYY')}
                                                        </span>
                                                        <span className="order-time" style={styles.orderTime}>
                                                            {moment(order.add_at).format('hh:mm A')}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </Card.Body>
                        </Card>

                        {/* Delivery Information Section */}
                        <Card style={styles.sectionCard}>
                            <Card.Body>
                                <div style={styles.sectionHeader}>
                                    <FaMapMarkerAlt style={styles.sectionIcon} />
                                    <h2 className="section-title" style={styles.sectionTitle}>معلومات التوصيل</h2>
                                </div>

                                <div className="form-grid" style={styles.formGrid}>
                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>المحافظة</label>
                                        <select
                                            style={{ ...styles.select, ...(errors.city ? styles.inputError : {}) }}
                                            value={formData.city}
                                            onChange={(e) => this.handleInputChange('city', e.target.value)}
                                        >
                                            <option value="1">اختر المحافظة</option>
                                            {['بغداد', 'بابل', 'الأنبار', 'البصرة', 'دهوك', 'القادسية', 'ديالى',
                                                'ذي قار', 'السليمانية', 'صلاح الدين', 'كركوك', 'كربلاء', 'المثنى',
                                                'النجف', 'نينوى', 'واسط', 'ميسان', 'اربيل'].map(city => (
                                                    <option key={city} value={city}>{city}</option>
                                                ))}
                                        </select>
                                        {errors.city && <span style={styles.errorText}>{errors.city}</span>}
                                    </div>

                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>المنطقة</label>
                                        <input
                                            type="text"
                                            style={styles.input}
                                            placeholder="أدخل المنطقة"
                                            value={formData.address}
                                            onChange={(e) => this.handleInputChange('address', e.target.value)}
                                        />
                                    </div>

                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>الصفحة</label>
                                        <div style={styles.selectWrapper}>
                                            <FaStore className="input-icon" style={styles.selectIcon} />
                                            <select
                                                style={{ ...styles.select, ...(errors.pageId ? styles.inputError : {}) }}
                                                value={formData.pageId}
                                                onChange={(e) => this.handleInputChange('pageId', e.target.value)}
                                            >
                                                <option value="non">اختر الصفحة</option>
                                                {pages.map((page) => (
                                                    <option key={page.id} value={page.id}>{page.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        {errors.pageId && <span style={styles.errorText}>{errors.pageId}</span>}
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>

                        {/* Products Section */}
                        <Card style={styles.sectionCard}>
                            <Card.Body>
                                <div style={styles.sectionHeader}>
                                    <FaShoppingCart style={styles.sectionIcon} />
                                    <h2 className="section-title" style={styles.sectionTitle}>اختر المنتجات</h2>
                                </div>

                                <div style={styles.productsSection}>
                                    <div style={styles.multiSelectWrapper}>
                                        <MultiSelect
                                            items={items}
                                            selectedItems={selectedItems}
                                            onChange={(selectedItems) => {
                                                // إعادة تعيين الكميات للمنتجات الجديدة
                                                const newQuantities = {};
                                                selectedItems.forEach(item => {
                                                    newQuantities[item.id] = this.state.productQuantities[item.id] || 1;
                                                });
                                                
                                                this.setState({ 
                                                    selectedItems, 
                                                    productQuantities: newQuantities,
                                                    errors: { ...this.state.errors, items: '' } 
                                                });
                                            }}
                                            height={300}
                                            showSelectedItems={false}
                                            showSelectAll={false}
                                            searchPlaceholder="ابحث عن المنتجات..."
                                        />
                                    </div>
                                    {errors.items && (
                                        <div style={styles.errorAlert}>
                                            <FaExclamationCircle />
                                            <span>{errors.items}</span>
                                        </div>
                                    )}

                                    {/* Selected Products */}
                                    {selectedItems.length > 0 && (
                                        <div style={styles.selectedProducts}>
                                            <h3 style={styles.selectedProductsTitle}>المنتجات المختارة</h3>
                                            <div className="products-grid" style={styles.productsGrid}>
                                                {selectedItems.map((item, i) => {
                                                    const quantity = productQuantities[item.id] || 1;
                                                    const remainingStock = item.count - quantity;
                                                    
                                                    return (
                                                        <div key={item.id} className="product-card" style={styles.productCard}>
                                                            <Image
                                                                src={`${host}files/${item.photo}`}
                                                                className="product-image"
                                                                style={styles.productImage}
                                                                onError={(e) => {
                                                                    e.target.src = '/placeholder-image.png'; // صورة بديلة في حالة الخطأ
                                                                }}
                                                            />
                                                            <div style={styles.productInfo}>
                                                                <h4 style={styles.productName}>{item.label}</h4>
                                                                <div className="quantity-control" style={styles.quantityControl}>
                                                                    <button
                                                                        style={{
                                                                            ...styles.quantityBtn,
                                                                            opacity: quantity <= 1 ? 0.5 : 1,
                                                                            cursor: quantity <= 1 ? 'not-allowed' : 'pointer'
                                                                        }}
                                                                        onClick={() => this.onChangeQuantity(item.id, -1, item)}
                                                                        disabled={quantity <= 1}
                                                                    >
                                                                        <FaMinus />
                                                                    </button>
                                                                    <input
                                                                        type="number"
                                                                        style={styles.quantityInput}
                                                                        value={quantity}
                                                                        readOnly
                                                                    />
                                                                    <button
                                                                        style={{
                                                                            ...styles.quantityBtnPlus,
                                                                            opacity: quantity >= item.count ? 0.5 : 1,
                                                                            cursor: quantity >= item.count ? 'not-allowed' : 'pointer'
                                                                        }}
                                                                        onClick={() => this.onChangeQuantity(item.id, 1, item)}
                                                                        disabled={quantity >= item.count}
                                                                    >
                                                                        <FaPlus />
                                                                    </button>
                                                                </div>
                                                                <span style={{
                                                                    ...styles.stockInfo,
                                                                    color: remainingStock <= 5 ? '#ef4444' : '#6b7280'
                                                                }}>
                                                                    المخزون المتبقي: {remainingStock}
                                                                    {remainingStock <= 5 && ' (كمية محدودة)'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Card.Body>
                        </Card>

                        {/* Final Details Section */}
                        <Card style={styles.sectionCard}>
                            <Card.Body>
                                <div style={styles.sectionHeader}>
                                    <FaMoneyBillWave style={styles.sectionIcon} />
                                    <h2 className="section-title" style={styles.sectionTitle}>التفاصيل النهائية</h2>
                                </div>

                                <div className="form-grid" style={styles.formGrid}>
                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>السعر الكلي (مع التوصيل) *</label>
                                        <div style={styles.priceInputWrapper}>
                                            <input
                                                type="number"
                                                style={{ 
                                                    ...styles.input, 
                                                    ...(errors.price ? styles.inputError : {}),
                                                    ...(formData.price && parseFloat(formData.price) >= 5 ? { borderColor: '#10b981' } : {})
                                                }}
                                                placeholder="الحد الأدنى 5"
                                                min="5"
                                                value={formData.price}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // السماح بإدخال الأرقام فقط والنقطة العشرية
                                                    if (value === '' || /^\d*\.?\d*$/.test(value)) {
                                                        this.handleInputChange('price', value);
                                                    }
                                                }}
                                                onBlur={(e) => {
                                                    // عند الخروج من الحقل، تحقق من القيمة
                                                    const value = e.target.value;
                                                    if (value && parseFloat(value) < 5) {
                                                        this.setState(prevState => ({
                                                            errors: { ...prevState.errors, price: 'الحد الأدنى للسعر هو 5' }
                                                        }));
                                                    }
                                                }}
                                            />
                                        </div>
                                        {errors.price && <span style={styles.errorText}>{errors.price}</span>}
                                        {formData.price && parseFloat(formData.price) > 0 && (
                                            <span style={{ 
                                                fontSize: '12px',
                                                color: parseFloat(formData.price) >= 5 ? '#10b981' : '#f59e0b',
                                                fontWeight: '500'
                                            }}>
                                                {parseFloat(formData.price) >= 5 
                                                    ? '✓ السعر صحيح' 
                                                    : `الحد الأدنى للسعر هو 5 (المُدخل: ${formData.price})`
                                                }
                                            </span>
                                        )}
                                    </div>

                                    <div style={styles.formGroup}>
                                        <label style={styles.label}>نوع الطلب</label>
                                        <div className="order-type-options" style={styles.orderTypeOptions}>
                                            {[
                                                { value: 'new', label: 'طلب جديد', color: '#10b981' },
                                                { value: 'dep', label: 'طلب مكرر', color: '#3b82f6' },
                                                { value: 'rep', label: 'استبدال', color: '#f59e0b' }
                                            ].map(type => (
                                                <label
                                                    key={type.value}
                                                    style={{
                                                        ...styles.orderTypeOption,
                                                        ...(formData.orderType === type.value ? {
                                                            ...styles.orderTypeOptionActive,
                                                            borderColor: type.color,
                                                            backgroundColor: `${type.color}10`
                                                        } : {})
                                                    }}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="orderType"
                                                        value={type.value}
                                                        checked={formData.orderType === type.value}
                                                        onChange={(e) => this.handleInputChange('orderType', e.target.value)}
                                                        style={styles.hiddenRadio}
                                                    />
                                                    <span style={{ color: formData.orderType === type.value ? type.color : '#6b7280' }}>
                                                        {type.label}
                                                    </span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>

                                    <div style={styles.formGroupFull}>
                                        <label style={styles.label}>ملاحظات</label>
                                        <textarea
                                            style={styles.textarea}
                                            rows="4"
                                            placeholder="أضف أي ملاحظات خاصة بالطلب..."
                                            value={formData.notes}
                                            onChange={(e) => this.handleInputChange('notes', e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div style={styles.submitSection}>
                                    <Button
                                        className="submit-button"
                                        style={styles.submitButton}
                                        onClick={this.submit}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    style={{ marginLeft: '10px' }}
                                                />
                                                جاري الإرسال...
                                            </>
                                        ) : (
                                            <>
                                                <FaCheckCircle style={{ marginLeft: '8px' }} />
                                                إرسال الطلب
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </Container>
            </div>
        );
    }
}

// Modern Styles
const styles = {
    pageContainer: {
        minHeight: '100vh',
        backgroundColor: '#f3f4f6',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    },
    loadingContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'
    },
    loadingCard: {
        background: 'white',
        borderRadius: '24px',
        padding: '48px',
        textAlign: 'center',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
    },
    loadingSpinner: {
        width: '64px',
        height: '64px',
        color: '#6366f1',
        marginBottom: '24px'
    },
    loadingTitle: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#1f2937',
        marginBottom: '8px'
    },
    loadingSubtitle: {
        fontSize: '16px',
        color: '#6b7280',
        margin: 0
    },
    header: {
        background: 'white',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'
    },
    headerContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 0',
        maxWidth: '1200px'
    },
    backButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#6366f1',
        textDecoration: 'none',
        fontSize: '16px',
        fontWeight: '500',
        transition: 'color 0.2s'
    },
    pageTitle: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#1f2937',
        margin: 0,
        flex: 1,
        textAlign: 'center'
    },
    progressContainer: {
        maxWidth: '1200px',
        margin: '32px auto 0'
    },
    progressBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'white',
        borderRadius: '16px',
        padding: '24px',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
    },
    progressStep: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        flex: 1
    },
    progressIcon: {
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        background: '#e5e7eb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#9ca3af',
        fontSize: '20px',
        transition: 'all 0.3s'
    },
    progressIconActive: {
        background: '#6366f1',
        color: 'white'
    },
    progressLabel: {
        fontSize: '14px',
        color: '#6b7280',
        fontWeight: '500',
        textAlign: 'center'
    },
    mainContainer: {
        maxWidth: '1200px',
        margin: '24px auto',
        paddingBottom: '48px'
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
    },
    sectionCard: {
        background: 'white',
        borderRadius: '16px',
        border: 'none',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
        overflow: 'hidden'
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '24px',
        paddingBottom: '16px',
        borderBottom: '2px solid #f3f4f6'
    },
    sectionIcon: {
        fontSize: '24px',
        color: '#6366f1'
    },
    sectionTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1f2937',
        margin: 0
    },
    formGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '20px'
    },
    formGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    formGroupFull: {
        gridColumn: '1 / -1',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    label: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#374151'
    },
    input: {
        padding: '12px 16px',
        fontSize: '16px',
        border: '2px solid #e5e7eb',
        borderRadius: '12px',
        outline: 'none',
        transition: 'border-color 0.2s',
        backgroundColor: '#f9fafb'
    },
    inputError: {
        borderColor: '#ef4444'
    },
    select: {
        padding: '12px 16px',
        fontSize: '16px',
        border: '2px solid #e5e7eb',
        borderRadius: '12px',
        outline: 'none',
        backgroundColor: '#f9fafb',
        cursor: 'pointer',
        width: '100%'
    },
    selectWrapper: {
        position: 'relative'
    },
    selectIcon: {
        position: 'absolute',
        left: '16px',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#6b7280',
        pointerEvents: 'none'
    },
    textarea: {
        padding: '12px 16px',
        fontSize: '16px',
        border: '2px solid #e5e7eb',
        borderRadius: '12px',
        outline: 'none',
        resize: 'vertical',
        backgroundColor: '#f9fafb'
    },
    errorText: {
        fontSize: '12px',
        color: '#ef4444',
        marginTop: '4px'
    },
    previousOrders: {
        marginTop: '32px',
        padding: '24px',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%)',
        borderRadius: '16px',
        border: '1px solid rgba(99, 102, 241, 0.1)'
    },
    previousOrdersHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '20px'
    },
    previousOrdersTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1e293b',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    orderCount: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#6366f1',
        backgroundColor: 'white',
        padding: '6px 12px',
        borderRadius: '20px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
    },
    ordersGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
        gap: '16px',
        maxHeight: '500px',
        overflowY: 'auto',
        padding: '4px',
        scrollBehavior: 'smooth'
    },
    orderCard: {
        background: 'white',
        borderRadius: '16px',
        padding: '20px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s ease',
        border: '2px solid transparent',
        position: 'relative',
        overflow: 'hidden'
    },
    orderCardSuccess: {
        borderColor: '#10b981',
        background: 'linear-gradient(to bottom, white, #f0fdf4)'
    },
    orderCardDanger: {
        borderColor: '#ef4444',
        background: 'linear-gradient(to bottom, white, #fef2f2)'
    },
    orderCardWarning: {
        borderColor: '#f59e0b',
        background: 'linear-gradient(to bottom, white, #fffbeb)'
    },
    orderCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px'
    },
    orderIdBadge: {
        background: '#6366f1',
        color: 'white',
        padding: '6px 12px',
        borderRadius: '8px',
        fontWeight: '700',
        fontSize: '14px'
    },
    orderIdText: {
        letterSpacing: '0.5px'
    },
    orderStatusBadge: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 12px',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600'
    },
    statusBadgeSuccess: {
        backgroundColor: '#d1fae5',
        color: '#065f46'
    },
    statusBadgeDanger: {
        backgroundColor: '#fee2e2',
        color: '#991b1b'
    },
    statusBadgeWarning: {
        backgroundColor: '#fef3c7',
        color: '#92400e'
    },
    orderCardBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginBottom: '16px'
    },
    orderDetailItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px'
    },
    orderDetailIcon: {
        color: '#6b7280',
        fontSize: '16px',
        width: '20px'
    },
    orderDetailLabel: {
        color: '#6b7280',
        fontWeight: '500'
    },
    orderDetailValue: {
        color: '#1f2937',
        fontWeight: '600',
        flex: 1
    },
    orderCardFooter: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: '12px',
        borderTop: '1px solid #e5e7eb'
    },
    orderDate: {
        fontSize: '13px',
        color: '#6b7280',
        fontWeight: '500'
    },
    orderTime: {
        fontSize: '12px',
        color: '#9ca3af'
    },
    orderHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '12px'
    },
    orderInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
    },
    orderNumber: {
        fontWeight: '600',
        color: '#1f2937'
    },
    statusIcon: {
        waiting: { color: '#f59e0b' },
        delivery: { color: '#3b82f6' },
        cancelled: { color: '#ef4444' },
        success: { color: '#10b981' },
        returned: { color: '#ef4444' }
    },
    productsSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
    },
    multiSelectWrapper: {
        borderRadius: '12px',
        overflow: 'hidden',
        border: '2px solid #e5e7eb'
    },
    errorAlert: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 16px',
        backgroundColor: '#fef2f2',
        color: '#ef4444',
        borderRadius: '12px',
        fontSize: '14px'
    },
    selectedProducts: {
        marginTop: '24px'
    },
    selectedProductsTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px'
    },
    productsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '16px'
    },
    productCard: {
        display: 'flex',
        gap: '16px',
        padding: '16px',
        backgroundColor: '#f9fafb',
        borderRadius: '12px',
        border: '1px solid #e5e7eb'
    },
    productImage: {
        width: '80px',
        height: '80px',
        objectFit: 'cover',
        borderRadius: '8px'
    },
    productInfo: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
    },
    productName: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#1f2937',
        margin: 0
    },
    quantityControl: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginTop: 'auto'
    },
    quantityBtn: {
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        border: 'none',
        backgroundColor: '#ef4444',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        fontSize: '16px',
        transition: 'transform 0.2s'
    },
    quantityBtnPlus: {
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        border: 'none',
        backgroundColor: '#10b981',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        fontSize: '16px',
        transition: 'transform 0.2s'
    },
    quantityInput: {
        width: '60px',
        textAlign: 'center',
        border: '2px solid #e5e7eb',
        borderRadius: '8px',
        padding: '6px',
        fontSize: '16px',
        fontWeight: '600'
    },
    stockInfo: {
        fontSize: '12px',
        color: '#6b7280'
    },
    priceInputWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    },
    currency: {
        position: 'absolute',
        right: '16px',
        color: '#6b7280',
        fontWeight: '600'
    },
    orderTypeOptions: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '12px'
    },
    orderTypeOption: {
        padding: '12px',
        borderRadius: '12px',
        border: '2px solid #e5e7eb',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s',
        fontWeight: '500'
    },
    orderTypeOptionActive: {
        borderWidth: '2px'
    },
    hiddenRadio: {
        display: 'none'
    },
    submitSection: {
        marginTop: '32px',
        textAlign: 'center'
    },
    submitButton: {
        padding: '16px 48px',
        fontSize: '18px',
        fontWeight: '600',
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '12px',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'transform 0.2s, box-shadow 0.2s',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
    }
};

export default Outs;